"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const DeleteCardButton_1 = __importDefault(require("../../atoms/DeleteCardButton"));
const bridge_1 = require("@completeanatomy/bridge");
const device_1 = require("@completeanatomy/device");
const ui_1 = require("@completeanatomy/ui");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const hooks_1 = require("../../hooks");
const providers_1 = require("../../providers");
function GroupLabelPart({ labelId, identifier, title, subtitle, selectedToolType, }, ref) {
    const { isDesktop } = (0, device_1.usePlatform)();
    const bridge = (0, bridge_1.useBridge)();
    const { selectedLabelPartID } = (0, hooks_1.useLabels)();
    const toolsService = (0, providers_1.useToolsService)();
    const labelManager = toolsService === null || toolsService === void 0 ? void 0 : toolsService.getLabelToolManager();
    const containerRef = (0, react_1.useRef)(null);
    const onDeleteHandler = (0, react_1.useCallback)((event) => {
        event.stopPropagation();
        bridge === null || bridge === void 0 ? void 0 : bridge.labelListDeleteAction({
            object: {
                identifier: identifier,
            },
        });
        bridge === null || bridge === void 0 ? void 0 : bridge.labelDeletePart(identifier);
        if (selectedLabelPartID === identifier) {
            labelManager === null || labelManager === void 0 ? void 0 : labelManager.deselectPart();
        }
        labelManager === null || labelManager === void 0 ? void 0 : labelManager.removePartFromGroupLabel(labelId, identifier);
    }, [bridge, identifier, labelId, labelManager, selectedLabelPartID]);
    const onClick = (0, react_1.useCallback)(() => {
        bridge === null || bridge === void 0 ? void 0 : bridge.labelSelectPart(identifier);
        labelManager === null || labelManager === void 0 ? void 0 : labelManager.selectPart(labelId, identifier);
    }, [bridge, identifier, labelId, labelManager]);
    const onClickHandler = (event) => {
        event.stopPropagation();
    };
    const events = (0, ui_1.getPointersEvents)();
    (0, ui_1.useEvent)(containerRef, events.down, onClickHandler);
    const isSelected = identifier === selectedLabelPartID;
    const isDeleteVisible = selectedToolType === bridge_schema_1.ToolType.LabelsLeft || bridge_schema_1.ToolType.LabelsRight;
    return ((0, jsx_runtime_1.jsxs)(Container, { id: identifier, ref: ref, selected: isSelected, onClick: onClick, "data-e2e": 'GroupLabelPart_Container', children: [(0, jsx_runtime_1.jsxs)(Titles, { ref: containerRef, "data-e2e": 'GroupLabelPart_Titles', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'GroupLabelPart_Title', children: title }), (0, jsx_runtime_1.jsxs)(Subtitle, { "data-e2e": 'GroupLabelPart_Subtitle', children: ["(", subtitle, ")"] })] }), isDeleteVisible && ((0, jsx_runtime_1.jsx)(StyledDeleteCardButton, { desktop: isDesktop, iconSize: 12, selected: isSelected, onClick: onDeleteHandler, "data-e2e": 'GroupLabelPart_StyledDeleteCardButton' }))] }));
}
exports.default = (0, react_1.forwardRef)(GroupLabelPart);
const Container = styled_components_1.default.div `
  display: flex;
  flex-shrink: 0;

  box-sizing: border-box;

  width: 100%;

  padding: 15px;

  background-color: ${({ theme, selected }) => selected ? theme.textSecondary : theme.secondary};
`;
const Titles = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  margin: 0 auto 0 0;
`;
const Title = styled_components_1.default.div `
  font-size: 16px;
`;
const Subtitle = styled_components_1.default.div `
  font-size: 14px;
  font-style: italic;
`;
const StyledDeleteCardButton = (0, styled_components_1.default)(DeleteCardButton_1.default) `
  position: relative;
  top: auto;
  left: auto;

  flex-shrink: 0;

  width: 20px;
  height: 20px;

  margin: auto 0 auto 0;

  color: ${({ theme, selected }) => selected ? theme.textSecondary : theme.secondary};

  background-color: ${({ theme, selected }) => selected ? theme.text : theme.textSecondary};

  opacity: 0;

  ${({ desktop }) => desktop
    ? (0, styled_components_1.css) `
          transition: opacity 0.3s;

          ${Container}:hover & {
            opacity: 1;
          }
        `
    : (0, styled_components_1.css) `
          opacity: 1;
        `};
`;
